import { Item } from "./index";
import { GetItemsRequest } from "./msg-get-line-items-req";
import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface GetItemsResponse extends ResponseData {
    type: '@stemcstudio/gradebook:get-items-response';
    value?: Item[];
}

/**
 * @hidden
 */
export function isGetItemsResponse(message: MessageEvent): message is MessageEvent<GetItemsResponse> {
    const duck = message as MessageEvent<GetItemsResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/gradebook:get-items-response') {
        return true;
    } else {
        return false;
    }
}

/**
 * @hidden
 */
export function createGetLineItemsResponse(value: Item[], request: GetItemsRequest): GetItemsResponse {
    return { value, id: request.id, type: '@stemcstudio/gradebook:get-items-response' };
}

/**
 * @hidden
 */
export function createGetLineItemsError(err: string, request: GetItemsRequest): GetItemsResponse {
    return { type: '@stemcstudio/gradebook:get-items-response', id: request.id, err };
}
